export const stagingColor = '#1d4ed8'; // blue-700
